<template>
  <div :class="{pageFull: isMainPage}"
    :style="pageStyle"
    ref="pageContent">
    <div v-if="isIntro && getMainPage.intro" :style="{backgroundImage: `url('${getMainPage.intro}')`}" class="mainPage" @click="goMain"></div>
    <div v-else-if="isMain && getMainPage.image" :style="{backgroundImage: `url('${getMainPage.image}')`}" class="mainPage"></div>
    <div v-else class="contentPage" :class="{listPage: isListPage}" :style="listTypeStyle">
      <div v-if="list && list.length"
        class="collectionItemList"
        :data-type="listType" :style="listStyle">
        <CollectionItem
          v-for="(item, index) in list"
          :key="item.collectionItemId"
          :locale="locale"
          :categoryId="categoryId"
          :lang="lang"
          :item="item"
          :data-item="item.collectionItemId"
          :collectionIcon="collectionIcon"
          :isCollectableUser="isCollectableUser"
          :itemIndex="index"
          :listColumns="listColumns"
          :listLength="list.length"
          :lastItemMargin="pageFrame" />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from './DetailSwiper'
import CollectionItem from './CollectionItem'

export default {
  name: 'CollectionPage',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'collectionItemId',
    'isMainPage', // mainPage || introPage
    'isCollectableUser'
  ],
  components: {
    Swiper,
    CollectionItem
  },
  computed: {
    getMainPage () {
      return this.$store.getters['collection/getCollectionMainPage']
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    isIntro () {
      return this.$route.name === 'collectionIntro'
    },
    isMain () {
      return this.$route.name === 'collectionMain'
    },
    isListPage () {
      return this.$route.name === 'collectionPage'
    },
    pageFrame () {
      const frame = this.$store.getters['collection/getPageFrame']
      return frame ? `${frame}px` : ''
    },
    pageStyle () {
      const frame = this.pageFrame
      return {
        ...frame && {
          ...!this.isMainPage && {
            paddingTop: frame,
          },
          paddingLeft: frame,
          paddingRight: frame,
          paddingBottom: frame,
        },
      }
    },
    listTypeStyle () {
      const frame = this.pageFrame
      return {
        ...!this.isListPage && {
          paddingBottom: frame
        },
        ...this.listType === 'list' && {
          maxWidth: 'none'
        }
      }
    },
    listType () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      return setting && setting.listType
    },
    listColumns () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      return setting && setting.columnRatio.length
    },
    listStyle () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const marginTb = setting && parseInt(setting.itemMarginTb) * 12
      const marginlr = setting && 4 + (parseInt(setting.itemMarginLr) - 1) * 8
      return setting && {
        gridTemplateColumns: setting.columnRatio.map(x => `${x}fr`).join(' '),
        gridRowGap: `${marginTb}px`, // 1-12, 2-24, "3-36", 4-48, 5-60
        gridColumnGap: `${marginlr}px`, // 1-4, "2-12", 3-20, 4-28, 5-36
      }
    },
    list () {
      // 지금 카테고리 정보(여기에 itemIndex있음)
      const getCategoryById = this.getCategoryById
      const categoryItems = (getCategoryById && getCategoryById.collectionItemIndex) || []
      return categoryItems.map(item => {
        // itemIndex별로 itemProperty에서 찾아 맵핑
        const getItemByItemId = this.$store.getters['collection/getItemByItemId'](item)
        return getItemByItemId
      }).filter(item => (item.categoryIds || []).includes(this.categoryId))
    },
    collectionIcon () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const collectionCategory = setting && setting.collectionCategory
      const useCollection = collectionCategory && setting && setting.useCollection
      const myCollectionSetting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`,
        collectionCategory: collectionCategory
      }
      return useCollection && scrapIcon
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.getMyCollectionItems()
      const pageContent = this.$refs.pageContent

      this.checkCategoryPage()

      // 아이템리스트에서 상세로 넘어갈 때 스크롤Y
      if (!from.params.collectionItemId && to.params.collectionItemId) {
        if (pageContent) {
          this.lastScroll = pageContent.scrollTop
        }
      }
      // 상세에서 아이템리스트로 돌아갈 때 스크롤Y
      if (from.params.collectionItemId && !to.params.collectionItemId) {
        this.$nextTick(() => {
          if (pageContent) {
            pageContent.scrollTo(0, this.lastScroll || 0)
          }
        })
      }
      // 콜렉션페이지인데 카테고리메인을 사용하면 collectionCategoryMain으로 라우터 이동 (back 버튼으로 상위 카테고리 탈 때)
      if (to.name === 'collectionPage' && this.getCategoryById && this.getCategoryById.useMain) {
        this.$router.replace({
          name: 'collectionCategoryMain',
          params: {
            ...this.$route.params
          }
        })
      }
    }
  },
  created () {
    this.checkCategoryPage()
  },
  mounted () {
    this.$nextTick(() => {
      this.getMyCollectionItems()
    })
  },
  data () {
    return {
      lastScroll: 0
    }
  },
  methods: {
    goMain () {
      this.$router.push({
        name: 'collectionMain',
        params: {
          ln: this.$route.params.ln,
          pageId: this.pageId
        }
      })
    },
    getMyCollectionItems () {
      this.$store.dispatch('collection/getMyCollectionItems', {pageId: this.pageId})
    },
    checkCategoryPage () {
      // 카테고리 메인페이지로 사용하지 않고 하위뎁스가 있으면 0번째 하위뎁스로 바로 이동
      if (!(this.isMain || this.isIntro) && this.getCategoryById && !this.getCategoryById.useMain && this.getCategoryById.subCategory) {
        this.$router.replace({
          params: {
            ...this.$route.params,
            categoryId: this.getCategoryById.subCategory[0].categoryId
          }
        })
      }
    }
  }
}
</script>